var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('v-pagination',{attrs:{"value":_vm.currentPage,"length":_vm.lastPage,"total-visible":_vm.$vuetify.breakpoint.smAndDown?5:8},on:{"input":_vm.paginatePage}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }